import React, { forwardRef } from 'react';
import { cx } from 'linaria';
import { useTranslation } from 'react-i18next';
import { MagnifyingGlassIcon } from '@fronton/icons-react';
import { getSearchComboboxAriaProps, SEARCH_INPUT_ID } from './utils/search-suggestions-aria';
import {
  searchbarInput,
  searchbarInputContainer,
  searchbarInputExpanded,
  searchbarInputIconDecoration,
} from './styles';

interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inputRef: React.RefObject<HTMLInputElement>;
  expanded: boolean;
  value: string;
  navigationIndex: number;
  listboxExpanded: boolean;
  collapse: () => void;
}

export const SEARCH_INPUT_QA = 'search-input';

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>((props, innerRef) => {
  const { expanded, navigationIndex, listboxExpanded, value, collapse, autoFocus, inputRef, ...rest } =
    props;

  const { t } = useTranslation();
  const comboboxAriaProps = getSearchComboboxAriaProps({ navigationIndex, listboxExpanded });

  return (
    <div className={searchbarInputContainer} ref={innerRef}>
      {!expanded && <MagnifyingGlassIcon className={searchbarInputIconDecoration} color="text-primary" />}
      <input
        ref={inputRef}
        form="headersearchform"
        className={cx(searchbarInput, expanded && searchbarInputExpanded)}
        type="search"
        name="q"
        value={value}
        {...rest}
        placeholder={t('header.searchbar.search')}
        aria-hidden={!expanded}
        tabIndex={expanded ? 0 : -1}
        aria-label={t('header.searchbar.search')}
        id={SEARCH_INPUT_ID}
        data-qa-header-search-input=""
        data-qa={SEARCH_INPUT_QA}
        autoComplete="off"
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck={false}
        {...comboboxAriaProps}
      />
    </div>
  );
});
